import React from 'react'
import TopBrands from './TopBrands'
import TopBrandsImages from './TopBrandsImages'

const MainTopBrands = () => {
  return (
    <>
        <TopBrands/>
        <TopBrandsImages/>
    </>
  )
}

export default MainTopBrands